/* EQ · Look complet — onglets + ajout au panier (produit seul ou look entier) via le tiroir natif Dawn. */
(function(){
  async function eqAddToCart(items){
    const r = await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items, sections:'cart-drawer,cart-icon-bubble'})});
    const j = await r.json();
    if(!r.ok){ alert(j.description || j.message || 'Impossible d’ajouter au panier'); return; }
    const drawer = document.querySelector('cart-drawer');
    if(drawer && j.sections && typeof drawer.renderContents === 'function'){ drawer.classList.remove('is-empty'); var inner = drawer.querySelector('.drawer__inner'); if(inner) inner.classList.remove('is-empty'); drawer.renderContents(j); }
    else { window.location.href = '/cart'; }
  }
  document.addEventListener('click', function(e){
    const tab = e.target.closest('[data-eq-look-tab]');
    if(tab){
      const root = tab.closest('.eq-look'); const id = tab.getAttribute('data-eq-look-tab');
      root.querySelectorAll('[data-eq-look-tab]').forEach(t=>t.classList.toggle('is-active', t===tab));
      root.querySelectorAll('[data-eq-look-panel]').forEach(p=>p.classList.toggle('is-active', p.getAttribute('data-eq-look-panel')===id));
      return;
    }
    const one = e.target.closest('[data-eq-add-variant]');
    if(one){ e.preventDefault(); one.disabled = true; eqAddToCart([{id: parseInt(one.dataset.eqAddVariant,10), quantity:1}]).finally(()=>{ one.disabled=false; }); return; }
    const all = e.target.closest('[data-eq-add-look]');
    if(all){ e.preventDefault(); const ids = all.dataset.eqAddLook.split(',').filter(Boolean).map(v=>({id:parseInt(v,10),quantity:1})); if(!ids.length) return; all.disabled=true; eqAddToCart(ids).finally(()=>{ all.disabled=false; }); }
  });
})();
